import { PortfolioType } from 'pco-product-service-internal-consumer';

export type PortfolioStatus = 'INITIAL' | 'ACTIVE' | 'CLOSED' | 'IN_CLOSING' | 'INACTIVE';

export enum PortfolioStatusState {
  INITIAL = 'INITIAL',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  IN_CLOSING = 'IN_CLOSING',
  INACTIVE = 'INACTIVE',
}

//TODO: Include current required parameter
export type CreatePortfolioData = {
  // portfolioNumber: string;
  sequenceNumber: number;
  rubrik: string;
  details: string;
  portfolioType: PortfolioType;
  portfolioTypeNumber?: string;
  portfolioStatus?: PortfolioStatus;
  referenceCurrency: string;
  chargingCurrency: string;
  // allocatedBo: string;
  businessRelationshipId: string;
  serviceAgreementId?: string;
  // closedAt?: string;
  cashAccounts: {
    currency: string;
    accountType: string;
  }[];
};

export interface PortfolioDataResponse {
  portfolioId: string;
  portfolioNumber: string;
  sequenceNumber?: number;
  rubrik: string;
  details: string;
  canEditDetails?: boolean;
  portfolioType: PortfolioType;
  portfolioStatus: PortfolioStatus;
  referenceCurrency: string;
  chargingCurrency: string;
  allocatedBo: string;
  specialBoEnabled?: boolean;
  businessRelationshipId: string;
  serviceAgreementId: string;
  closedAt: Date;
  cashAccounts: {
    blocked?: boolean;
    currency: string;
    accountType: string;
    accountStatus: string;
  }[];
}

export type PortfolioListResponse = {
  list: PortfolioDataResponse[];
};

export type BeneficialOwner = {
  partnerUid: string;
  partnerId: string;
  roleType: string;
  partnerToBrRole: string;
  partnerName: string;
  partnerStructureType: string;
  partnerImported: boolean;
  validFrom: string;
};
